import { enablePressFeedback } from "@tredco/ui/press-feedback"
import posthog from "posthog-js"
import { createApp } from "vue"
import { i18n, initializeLocale } from "../localization/i18n"
import App from "./App.vue"
import "../assets/css/styles.css"

const app = createApp(App)

// Standalone page: the PostHog project token is a public client token, pinned
// here the same way the main app pins it via build-time config.
if (import.meta.env.PROD) {
  posthog.init("phc_fwbxaZPm9FB5wA21S5I9bJw2hD1qXMTb6m6ecpUOSn0", {
    api_host: "https://eu.i.posthog.com",
    persistence: "localStorage",
    capture_exceptions: true,
  })
  // capture_exceptions only hooks the window channels; Vue 3 swallows
  // component errors in production unless an errorHandler is installed.
  // console.error keeps the error visible in devtools too — installing a
  // handler replaces Vue's default prod logging.
  app.config.errorHandler = (err) => {
    console.error(err)
    posthog.captureException(err)
  }
}

app.use(i18n)

// WebKit shows the design system's pressed states only on a page that listens for touches (row 144).
enablePressFeedback()
// The page opens in its `?language=`; a dictionary that fails to load leaves
// it in Norwegian rather than blank.
void initializeLocale().then(() => app.mount("#app"))
